import { Link } from 'react-router-dom';
import { ArrowUpRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { BOOK_TRIAL_URL } from '../lib/config';

export default function CTABand() {
  return (
    <section className="pt-10 md:pt-14 pb-6 md:pb-8" aria-labelledby="cta-heading">
      <div className="container">
        <div className="relative rounded-[2rem] overflow-hidden bg-brand-sun p-8 md:p-12 lg:p-14 grid md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-brand-coral/40 blur-3xl" aria-hidden="true" />
          <div className="absolute -bottom-20 -left-16 w-72 h-72 rounded-full bg-brand-mint blur-3xl" aria-hidden="true" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full bg-brand-ink text-brand-cream px-3.5 py-1.5 text-xs font-semibold uppercase tracking-widest">
              <Sparkles className="w-3.5 h-3.5" aria-hidden="true" /> Free trial lesson available
            </div>
            <h2 id="cta-heading" className="mt-4 font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-tight">
              Ready to make science click?
            </h2>
            <p className="mt-3 text-brand-ink/80 text-base md:text-lg max-w-lg">
              Book a free one-hour trial lesson. Your child can experience our teaching before deciding whether to join - there is no obligation to continue.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row flex-wrap gap-3">
              <Button
                asChild
                size="lg"
                className="bg-brand-ink text-brand-cream hover:bg-brand-teal rounded-full h-12 px-6"
              >
                <a
                  href={BOOK_TRIAL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gap-2"
                >
                  Book a free trial <ArrowUpRight className="w-4 h-4" />
                </a>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="rounded-full h-12 px-6 border-brand-ink/20 bg-white/70 hover:bg-white"
              >
                <Link to="/courses">Explore courses</Link>
              </Button>
            </div>
          </div>
          <div className="relative hidden md:block">
            <div className="aspect-square rounded-[1.75rem] overflow-hidden">
              <img
                src="/hero/cta-lesson.webp"
                alt="A cosy home study desk with a laptop showing a Science Sorted Google Meet lesson on Photosynthesis and Plant Cells, revision notes and a coffee alongside"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
